import { Carousel } from '@material-tailwind/react';
import React from 'react';
import useCarousel from './hooks/useCarousel';
import { IMAGE_LIST } from '../../constants/bannerData';

const CarouselNavigation = () => {
  const { list, clickHandler } = useCarousel(IMAGE_LIST);
  return (
    <Carousel
      autoplay
      loop
      navigation={({ setActiveIndex, activeIndex, length }) => (
        <div className="absolute bottom-4 left-2/4 z-50 flex -translate-x-2/4 gap-2">
          {new Array(length).fill('').map((_, i) => (
            <span
              key={i}
              className={`block h-2 cursor-pointer rounded-full transition-all content-[''] shadow-md ${
                activeIndex === i
                  ? 'w-4 bg-white'
                  : 'w-2 bg-white/50 hover:bg-white/80'
              }`}
              onClick={() => setActiveIndex(i)}
            />
          ))}
        </div>
      )}
    >
      {list.map(({ img, mobile, title, link, type }, key) => (
        <div
          key={key}
          onClick={() => clickHandler(link, type)}
          className="cursor-pointer"
        >
          <img
            src={process.env.PUBLIC_URL + img}
            alt={title}
            className="h-full w-full max-h-[423px] object-cover hidden lg:block"
          />
          <img
            src={process.env.PUBLIC_URL + mobile}
            alt={title}
            className="h-full w-full max-h-[423px] object-cover block lg:hidden"
          />
        </div>
      ))}
    </Carousel>
  );
};

export default CarouselNavigation;
